import * as React from 'react';
import { mappingHasProperty } from '../helper';
import { convertToLinkObject } from './profile-teaser/helper';

export function useProfileTeaserFields(hit, mapping) {
  return React.useMemo(() => {
    const getValue = (key, defaultValue = '') => mappingHasProperty(mapping, hit, key) ? hit[mapping[key]] : defaultValue;
    let links = [];
    getValue('links', []).forEach(entry => {
      const link = convertToLinkObject(entry);
      if (link) { links.push(link); }
    });

    return {
      title: getValue('title'),
      jobRole: getValue('job_role'),
      image: getValue('profile_image_url'),
      specialization: getValue('specialization'),
      institutionName: getValue('institution_name'),
      pageUrl: getValue('profile_page_url'),
      links,
    };
  }, [hit, mapping]);
}
